import { ProgramObjectivesBadge } from '@components/buzzkuri/shared/uiParts/badge/ProgramObjectives'
import { ProgramTagsBadge } from '@components/buzzkuri/shared/uiParts/badge/ProgramTags'
import { PageMajorHeading } from '@components/buzzkuri/shared/uiParts/heading/PageMajorHeading'
import { ImageWraper } from '@components/shared/wraper/ImageWraper'
import { BREAKPOINTS } from '@constants/common'
import { WindowSizeContext } from '@context/WindowSize/Context'
import { ProgramBase } from '@type/buzzkuri/program-detail'
import React, { useContext } from 'react'

type Props = ProgramBase

export const ProgramBaseInfo = ({
  title,
  objectives,
  genre,
  tags,
  imagePath,
}: Props): JSX.Element => {
  const winSize = useContext(WindowSizeContext)

  return (
    <div className="flex flex-col-reverse lg:flex-col w-[87.2vw] lg:w-[62.6vw]">
      <div className="flex flex-col">
        <div className="mt-[3vw] lg:mt-0 ">
          {winSize?.width > BREAKPOINTS.laptop ? (
            <div className="text-[4.8vw] lg:text-[2.3vw] font-bold tracking-[0.4vw] lg:tracking-normal leading-[6.9vw] lg:leading-[3.9vw] text-black">
              <h1>{title}</h1>
            </div>
          ) : (
            <PageMajorHeading mainHeading={title} MainHeadingTag="h1" />
          )}
        </div>

        <div className="mt-[3vw] lg:mt-[2.3vw]">
          <ProgramObjectivesBadge objectives={[genre, ...objectives]} />
        </div>
        <div>
          <ProgramTagsBadge {...{ tags }} />
        </div>
      </div>
      <div className="lg:mt-[0.8vw]">
        <ImageWraper
          src={imagePath}
          width={920}
          height={450}
          alt={`${title}のイメージ画像`}
          priority={true}
        />
      </div>
    </div>
  )
}
